import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuoteTemplateService } from 'src/app/quote-template-new/services/quote-template.service';

@Component({
    selector: 'app-Select-Contact',
    templateUrl: './select_contact.component.html',
    styleUrls: ['./select_contact.component.scss'],
    standalone: false
})
export class SelectContactComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject();
  public fg: FormGroup;
  selectedContact: any = '';
  userName: string = '';
  fullContactInfo:any=''
  languageCtrl: FormControl = new FormControl();
  languageSearchCtrl: FormControl = new FormControl();
  // nameControl = new FormControl('', Validators.required);
  metaLanguages = [
    { name: "Afrikaans", code: "af" },
    { name: "Albanian", code: "sq" },
    { name: "Arabic", code: "ar" },
    { name: "Arabic (EGY)", code: "ar_EG" },
    { name: "Arabic (UAE)", code: "ar_AE" },
    { name: "Arabic (LBN)", code: "ar_LB" },
    { name: "Arabic (MAR)", code: "ar_MA" },
    { name: "Arabic (QAT)", code: "ar_QA" },
    { name: "Azerbaijani", code: "az" },
    { name: "Belarusian", code: "be" },
    { name: "Bengali", code: "bn" },
    { name: "Bengali (IND)", code: "bn_IN" },
    { name: "Bulgarian", code: "bg" },
    { name: "Catalan", code: "ca" },
    { name: "Chinese (CHN)", code: "zh_CN" },
    { name: "Chinese (HKG)", code: "zh_HK" },
    { name: "Chinese (TAI)", code: "zh_TW" },
    { name: "Croatian", code: "hr" },
    { name: "Czech", code: "cs" },
    { name: "Danish", code: "da" },
    { name: "Dutch", code: "nl" },
    { name: "Dutch (BEL)", code: "nl_BE" },
    { name: "English", code: "en" },
    { name: "English (US)", code: "en_US" },
    { name: "English (UK)", code: "en_GB" },
    { name: "English (AUS)", code: "en_AU" },
    { name: "English (CAN)", code: "en_CA" },
    { name: "English (IRL)", code: "en_IE" },
    { name: "English (IND)", code: "en_IN" },
    { name: "English (JAM)", code: "en_JM" },
    { name: "English (MYS)", code: "en_MY" },
    { name: "English (NZL)", code: "en_NZ" },
    { name: "English (QAT)", code: "en_QA" },
    { name: "English (SGP)", code: "en_SG" },
    { name: "English (UAE)", code: "en_AE" },
    { name: "English (UGA)", code: "en_UG" },
    { name: "English (GHA)", code: "en_GH" },
    { name: "Estonian", code: "et" },
    { name: "Filipino", code: "fil" },
    { name: "Finnish", code: "fi" },
    { name: "French", code: "fr" },
    { name: "French (BEL)", code: "fr_BE" },
    { name: "French (CAN)", code: "fr_CA" },
    { name: "French (CHE)", code: "fr_CH" },
    { name: "French (CIV)", code: "fr_CI" },
    { name: "French (MAR)", code: "fr_MA" },
    { name: "Georgian", code: "ka" },
    { name: "German", code: "de" },
    { name: "German (AUT)", code: "de_AT" },
    { name: "German (CHE)", code: "de_CH" },
    { name: "Greek", code: "el" },
    { name: "Gujarati", code: "gu" },
    { name: "Hebrew", code: "he" },
    { name: "Hindi", code: "hi" },
    { name: "Hungarian", code: "hu" },
    { name: "Indonesian", code: "id" },
    { name: "Irish", code: "ga" },
    { name: "Italian", code: "it" },
    { name: "Japanese", code: "ja" },
    { name: "Kannada", code: "kn" },
    { name: "Kazakh", code: "kk" },
    { name: "Kinyarwanda", code: "rw" },
    { name: "Korean", code: "ko" },
    { name: "Kyrgyz (Kyrgyzstan)", code: "ky_KG" },
    { name: "Lao", code: "lo" },
    { name: "Latvian", code: "lv" },
    { name: "Lithuanian", code: "lt" },
    { name: "Macedonian", code: "mk" },
    { name: "Malay", code: "ms" },
    { name: "Malayalam", code: "ml" },
    { name: "Marathi", code: "mr" },
    { name: "Norwegian", code: "no" },
    { name: "Pashto", code: "ps" },
    { name: "Persian", code: "fa" },
    { name: "Polish", code: "pl" },
    { name: "Portuguese (BR)", code: "pt_BR" },
    { name: "Portuguese (POR)", code: "pt_PT" },
    { name: "Punjabi", code: "pa" },
    { name: "Romanian", code: "ro" },
    { name: "Russian", code: "ru" },
    { name: "Serbian", code: "sr" },
    { name: "Sinhala", code: "si" },
    { name: "Slovak", code: "sk" },
    { name: "Slovenian", code: "sl" },
    { name: "Spanish", code: "es" },
    { name: "Spanish (ARG)", code: "es_AR" },
    { name: "Spanish (CHL)", code: "es_CL" },
    { name: "Spanish (COL)", code: "es_CO" },
    { name: "Spanish (CRI)", code: "es_CR" },
    { name: "Spanish (DOM)", code: "es_DO" },
    { name: "Spanish (ECU)", code: "es_EC" },
    { name: "Spanish (SPA)", code: "es_ES" },
    { name: "Spanish (HND)", code: "es_HN" },
    { name: "Spanish (MEX)", code: "es_MX" },
    { name: "Spanish (PAN)", code: "es_PA" },
    { name: "Spanish (PER)", code: "es_PE" },
    { name: "Spanish (URY)", code: "es_UY" },
    { name: "Swahili", code: "sw" },
    { name: "Swedish", code: "sv" },
    { name: "Tamil", code: "ta" },
    { name: "Telugu", code: "te" },
    { name: "Thai", code: "th" },
    { name: "Turkish", code: "tr" },
    { name: "Ukrainian", code: "uk" },
    { name: "Urdu", code: "ur" },
    { name: "Uzbek", code: "uz" },
    { name: "Vietnamese", code: "vi" },
    { name: "Zulu", code: "zu" },
    { name: "Dari", code: "prs" }
  ];

  filteredLanguages = [...this.metaLanguages];
  templateList: any[] = [];
  constructor(public dialogRef: MatDialogRef<SelectContactComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any,public QuoteTemplateServices: QuoteTemplateService,) {
    this.fg = new FormGroup({
      name: new FormControl(
        '',
        [
          Validators.required,
          Validators.pattern(/^[a-z0-9]+(?:_[a-z0-9]+)*$/)
        ]
      )
    });
   }

   async ngOnInit(): Promise<void> {
    await this.getTemplates();
  
    const rawContact = this.dialogData?.apiData?.contact_number;

  if (rawContact && this.dialogData?.contact?.length) {
    try {
      const parsed = JSON.parse(rawContact);

      // Match by mobile number without spaces
      this.selectedContact = this.dialogData.contact.find(
        obj => obj.mobile_number.replace(/\s+/g, '') === parsed.mobile_number.replace(/\s+/g, '')
      );
    
    } catch (err) {
      console.error('Failed to parse contact_number:', err);
    }
  }
    
    
    this.languageSearchCtrl.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(search => {
      if (!search) {
        this.filteredLanguages = [...this.metaLanguages];
        return;
      }
      const filter = search.toLowerCase();
      this.filteredLanguages = this.metaLanguages.filter(lang =>
        lang.name.toLowerCase().includes(filter) || lang.code.toLowerCase().includes(filter)
      );
    });
    if (this.dialogData?.apiData?.template_name) {
      this.fg.get('name')?.setValue(this.dialogData.apiData.template_name);
    }
    if (this.dialogData?.apiData?.language) {
      this.languageCtrl.setValue(this.dialogData?.apiData?.language)
    }

    this.fg.get('name')?.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(selectedName => {
      const matchedTemplate = this.templateList.find(t => t.name === selectedName);
      if (matchedTemplate) {
        this.languageCtrl.setValue(matchedTemplate.language);
      }
    });
  }  
  closeDialogThankYou(){
    this.dialogRef.close(true); 
  }
  closeDialog(){
    this.dialogRef.close(false);
  }

  onSelectedOption(selectedObj: any): void {
    
    this.fullContactInfo=selectedObj    
    // if (selectedObj && selectedObj.mobile_number && selectedObj.country?.phone_code) {
    //   const formattedNumber = this.convertToInternational(selectedObj.mobile_number, selectedObj.country.phone_code);
    //   this.selectedContact=formattedNumber
    // }
  }
  
   convertToInternational(mobileNumber: string, phoneCode: string): string {
    // Remove all non-digit characters
    let cleanedNumber = mobileNumber.replace(/\D/g, '');
  
    // If the number starts with a leading zero, remove it
    if (cleanedNumber.startsWith('0')) {
      cleanedNumber = cleanedNumber.substring(1);
    }
  
    // Return the formatted international number
    return `+${phoneCode}${cleanedNumber}`;
  }
  

  submit() {
    let contactToSend = this.selectedContact;
    if (typeof contactToSend === 'object') {
      contactToSend = this.convertToInternational(
        contactToSend.mobile_number,
        contactToSend.country.phone_code
      );
    }
  
    this.dialogRef.close({
      contact: contactToSend,
      language: this.languageCtrl.value,
      name: this.fg.get('name').value,
      contactInfo: this.fullContactInfo
    });
  }
  
  
  isFormValid(): boolean {
    return this.fg.valid && this.selectedContact !== '' && this.languageCtrl.value;
  }

  onNameInput(): void {
    const ctrl = this.fg.get('name');
    const value = ctrl?.value || '';
  
    // Remove disallowed characters, convert to lowercase
    const cleaned = value
      .toLowerCase()
      .replace(/[^a-z0-9_]/g, '')        // only allow lowercase letters, digits, and underscores
      .replace(/_{2,}/g, '_');           // replace multiple underscores with one (optional)
    
    if (value !== cleaned) {
      ctrl?.setValue(cleaned, { emitEvent: false }); // prevent infinite loop
    }
  }
  async getTemplates() {
    this.QuoteTemplateServices.getWhatsAppTem({ keys: this.dialogData?.metaData })
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res: any) => {
        if (res && Array.isArray(res)) {
          this.templateList = res;
        }
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }
}
